module.exports = __webpack_public_path__ + "static/img/OM4.1c7650d1.png";